import axios from 'axios'
import LoadingV2 from 'components/LoadingV2'
import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'

const GenericPDFPreview = () => {
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const [searchParams] = useSearchParams()
  const { token } = useSelector((s) => s.auth)

  const [pdfUrl, setPdfUrl] = useState(null)
  const [isLoadingPdf, setIsLoadingPdf] = useState(false)

  const documentUrl = searchParams.get('url')
  const documentTitle = searchParams.get('title') || 'Preview Dokumen'

  useEffect(() => {
    if (documentUrl) {
      loadPDF()
    } else {
      enqueueSnackbar('URL dokumen tidak ditemukan', { variant: 'error' })
      navigate(-1)
    }
  }, [documentUrl])

  const loadPDF = async () => {
    try {
      setIsLoadingPdf(true)
      const response = await axios.get(documentUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      })

      const blobFile = new Blob([response.data], { type: 'application/pdf' })
      const url = window.URL.createObjectURL(blobFile)
      setPdfUrl(url)
    } catch (error) {
      console.error('Error loading PDF:', error)
      enqueueSnackbar('Gagal memuat dokumen', { variant: 'error' })
      navigate(-1)
    } finally {
      setIsLoadingPdf(false)
    }
  }

  useEffect(() => {
    return () => {
      if (pdfUrl) {
        window.URL.revokeObjectURL(pdfUrl)
      }
    }
  }, [pdfUrl])

  if (isLoadingPdf) {
    return (
      <div
        style={{
          width: '100vw',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f8f9fa',
        }}
      >
        <LoadingV2 />
      </div>
    )
  }

  if (!pdfUrl) {
    return (
      <div
        style={{
          width: '100vw',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f8f9fa',
        }}
      >
        <p style={{ color: '#6c757d' }}>Gagal memuat PDF</p>
      </div>
    )
  }

  return (
    <iframe
      src={pdfUrl}
      style={{
        width: '100vw',
        height: '100vh',
        border: 'none',
        margin: 0,
        padding: 0,
        display: 'block',
      }}
      title={documentTitle}
    />
  )
}

export default GenericPDFPreview
